import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';

const RepairCostsByCategory = ({ data }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <HandymanOutlinedIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
            Service Costs by Category
          </Typography>
        </Box>

        {/* Stacked Bar */}
        <Box
          sx={{
            display: 'flex',
            height: 16,
            borderRadius: 2,
            overflow: 'hidden',
            mb: 3,
          }}
        >
          {data.categories.map((cat) => (
            <Box
              key={cat.name}
              sx={{
                width: `${cat.change}%`,
                bgcolor: cat.color,
                transition: 'width 0.3s',
              }}
            />
          ))}
        </Box>

        {/* Column Headers */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', fontSize: '0.8125rem', fontWeight: 500, flex: 1 }}
          >
            Cost Breakdown
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', fontSize: '0.8125rem', fontWeight: 500, minWidth: 70, textAlign: 'right' }}
            >
              Unplanned
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', fontSize: '0.8125rem', fontWeight: 500, minWidth: 60, textAlign: 'right' }}
            >
              Planned
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', fontSize: '0.8125rem', fontWeight: 500, minWidth: 50, textAlign: 'right' }}
            >
              Change(%)
            </Typography>
          </Box>
        </Box>

        {/* Category Rows */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {data.categories.map((cat) => (
            <Box
              key={cat.name}
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: cat.color,
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}>
                  {cat.name}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.primary', minWidth: 70, textAlign: 'right' }}
                >
                  {cat.unplanned}
                </Typography>
                <Typography
                  sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.primary', minWidth: 60, textAlign: 'right' }}
                >
                  {cat.planned}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: 'text.secondary', fontSize: '0.8125rem', minWidth: 50, textAlign: 'right' }}
                >
                  {cat.change}%
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Total */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 3,
            pt: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            Total Planned Costs
          </Typography>
          <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: 'text.primary' }}>
            {data.total}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RepairCostsByCategory;
